/**
  * API接口默认参数配置
  */
// export const API_DEFAULT_CONFIG = {
//   mockBaseUrl: 'https://dynb.16bus.net',
//   prodBaseUrl: 'https://dynb.16bus.net',
//   isMocked: process.env.NODE_ENV !== 'production',
//   isDebug: true,
//   sep: '.',
//   // centerPoint:["108.947034",'34.259543'],//获取不到，默认中心点
//   centerPoint:["118.674633",'37.434107'],//获取不到，默认中心点
//   cityName:'东营市',
//   requestId:'9d7db2f30a361a15cf60430e79174a7f',
//   cityCode:'370500'
  
// }
let API_DEFAULT_CONFIG = Object.assign(window.systemConfig.api, {isMocked: process.env.NODE_ENV !== 'production'})
// console.log(12568,window.systemConfig)
/**
 * 默认接口URL
 */
export const baseUrl = process.env.NODE_ENV === 'production' ? API_DEFAULT_CONFIG.prodBaseUrl : API_DEFAULT_CONFIG.mockBaseUrl
